exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
var urlEscape = require("../../../../../node_modules/css-loader/dist/runtime/url-escape.js");
var ___CSS_LOADER_URL___0___ = urlEscape(require("./resources/cover.jpg"));

// Module
exports.push([module.id, ".with-background-image {\n\twidth: 100%;\n\theight: 740px;\n\tbackground-image: url(" + ___CSS_LOADER_URL___0___ + ");\n\tbackground-position: center;\n\tbackground-repeat: no-repeat;\n}\n\n\n#home {\n\tbackground-color: #000;\n}\n\n\n@media only screen and (max-width: 600px) {\n\t.with-background-image {\n\t\tbackground-image: url(" + ___CSS_LOADER_URL___0___ + ");\n\t\tbackground-position: top left;\n\t\tbackground-repeat: no-repeat;\n\t}\n}", ""]);

